//欢迎语
// const ms_welcome_title = "外贸通宝";
// const ms_welcome_tip   = "温馨提示：请不要调皮地在此粘贴执行任何内容，这可能会导致您的账户受到攻击，给您带来损失 ！^_^";
// const ms_welcome_con   = "如果您喜欢我们的工作。欢迎加入我们： QQ:957987132";
// console.log("%c "+ ms_welcome_title +" %c Copyright \xa9 2007-%s\n%c" + ms_welcome_tip + "\n %c" + ms_welcome_con + "\n ", 'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;font-size:64px;color:#00bbee;-webkit-text-fill-color:#00bbee;-webkit-text-stroke: 1px #00bbee;', "font-size:12px;color:#999999;", (new Date).getFullYear(), "color:#333;font-size:16px;", "font-size:12px;");

//调用
import Vue from "vue";
import router from "./router";
import store from "./store";
import App from "./App";
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)


//关闭生产环境提示
Vue.config.productionTip = false;

//plugins
import "./plugins/iview.js";
import "./plugins/vueScroll.js";
import "./plugins/assetsJs.js";

//导入基础样式
import "@/assets/css/base.css";
//导入公共js
import "@/assets/js/prefixfree.min.js";
import "@/assets/js/flexible.js";

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});
